import { gql } from '@apollo/client';

export const orderStatusQueryApollo = gql`
  query OrderStatus($orderId: UUID!) {
    orderStatus(orderId: $orderId) {
      orderId
      status
      underwritingResultStatus
      errors {
        message
        code
      }
    }
  }
`;
